export const Goto = ({
  color = "#706A85",
  size = "16",
  stroke = "1.4",
}: {
  color?: string;
  size?: string;
  stroke?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_669_42382)">
        <path
          d="M1.5 8H8.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={stroke}
        />
        <path
          d="M6 5.5L8.5 8L6 10.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={stroke}
        />
        <path
          d="M8.5 2.5H12C12.1326 2.5 12.2598 2.55268 12.3536 2.64645C12.4473 2.74021 12.5 2.86739 12.5 3V13C12.5 13.1326 12.4473 13.2598 12.3536 13.3536C12.2598 13.4473 12.1326 13.5 12 13.5H8.5"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={stroke}
        />
      </g>
      <defs>
        <clipPath id="clip0_669_42382">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
